import React from 'react';
import { Link } from 'react-router-dom';
import { LegalLayout } from './LegalLayout';
import { LEGAL_DOCS } from './legalDocs';
import { Seo } from '../../components/seo/Seo';

export default function LegalIndexPage() {
  return (
    <LegalLayout>
      <Seo
        title="Legal | Hustli"
        description="Policies, terms, and compliance documents for Hustli."
        path="/legal"
      />
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-dark">Legal</h1>
        <p className="mt-2 text-stone-600">Clean, readable policy pages with downloadable source PDFs.</p>
      </div>

      <div className="grid sm:grid-cols-2 gap-4">
        {LEGAL_DOCS.map((doc) => (
          <div key={doc.slug} className="rounded-2xl border border-stone-200 bg-white p-5 shadow-sm">
            <div className="text-lg font-bold text-dark">{doc.title}</div>
            <div className="mt-4 flex flex-wrap gap-3">
              <Link
                to={`/legal/${doc.slug}`}
                className="inline-flex items-center justify-center rounded-xl bg-primary text-white px-4 py-2 font-semibold hover:bg-primary/90 transition-colors"
              >
                Read online
              </Link>
            </div>
          </div>
        ))}
      </div>
    </LegalLayout>
  );
}

